import { gql } from 'apollo-boost';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

const fragments = {
  alertDetail: gql`
    fragment AlertDetail on ManualAlert {
      name
      id
      filter {
        id
        name
        isAdvanced
      }
      metric
      type
      threshold
      direction
      samples
      priority
      cooldown
      state
      emails
      lifespan
      attachment
      totalEvents
      changedAt
    }
  `,
  eventDetail: gql`
    fragment EventDetail on ManualAlertEvent {
      id
      alertId
      time
      value
      samples
      window
      sent
    }
  `,
};

export const ALERT_SUMMARY_QUERY = () => {
  const alertType = CURRENT_PRODUCT_MODE === 'EI' ? 0 : 2;
  return gql`{
    manualAlertsByType(type: ${alertType}) {
      ...AlertDetail
      events(start: 0, count: 5) {
        ...EventDetail
      }
    }
  }
  ${fragments.alertDetail}
  ${fragments.eventDetail}
  `;
};

export const ALERT_DIAGNOSTICS_QUERY = () => {
  const alertType = CURRENT_PRODUCT_MODE === 'EI' ? 0 : 2;
  return gql`{
    manualAlertsByType(type: ${alertType}) {
      ...AlertDetail
    }
  }
  ${fragments.alertDetail}
  `;
};

export const ALERT_DIAGNOSTICS_EVENTS_QUERY = (count: number) => gql`
query ManualAlerts($ids: [Int!]!, $startTime: DateTime, $endTime: DateTime) {
  manualAlerts(ids: $ids) {
    ...AlertDetail
    events(startTime: $startTime, endTime: $endTime, count: ${count}) {
      ...EventDetail
    }
  }
}
${fragments.alertDetail}
${fragments.eventDetail}
`;

export const ALERT_EVENT_QUERY = gql`
  query ManualAlertEvent($ids: [Int!]!) {
    manualAlertEvents(ids: $ids) {
      ...EventDetail
      alert {
        name
        metric
        filter {
          name
          id
          rule
          isAdvanced
        }
      }
    }
  }
  ${fragments.eventDetail}
`;

export const ALERT_EVENTS_QUERY = gql`
  query ManualAlerts($ids: [Int!]!, $start: Int!, $count: Int!) {
    manualAlerts(ids: $ids) {
      ...AlertDetail
      events(start: $start, count: $count) {
        ...EventDetail
      }
    }
  }
  ${fragments.alertDetail}
  ${fragments.eventDetail}
`;

export const TOGGLE_ALERTS = gql`
  mutation ToggleAlerts($alertIds: [Int!]!, $state: Boolean!) {
    toggleManualAlerts(alertIds: $alertIds, state: $state) {
      id
      state
      name
    }
  }
`;

export const DELETE_ALERTS = () => {
  const alertType = CURRENT_PRODUCT_MODE === 'EI' ? 0 : 2;
  return gql`
    mutation DeleteAlerts($alertIds: [Int]!) {
      deleteManualAlerts(alertIds: $alertIds, type: ${alertType}) {
        id,
      }
    }
  `;
};

export const CREATE_ALERT = gql`
  mutation CreateManualAlert($payload: ManualAlertInput!) {
    createManualAlert(payload: $payload) {
      ...AlertDetail
      events {
        ...EventDetail
      }
    }
  }
  ${fragments.alertDetail}
  ${fragments.eventDetail}
`;

export const UPDATE_ALERT = gql`
  mutation UpdateManualAlert($alertId: Int!, $payload: ManualAlertInput!) {
    updateManualAlert(alertId: $alertId, payload: $payload) {
      ...AlertDetail
    }
  }
  ${fragments.alertDetail}
`;

export const ALERT_FILTERS = gql`
  {
    self {
      user {
        username
      }
      customer {
        filters {
          id
          name
          isAdvanced
        }
      }
    }
  }
`;
